module.exports = __webpack_public_path__ + "img/scene_wakeup_tw_backlight@2x.ce377b0e.png";